import { InvoiceDisplayStatusV2 } from 'anchor-scout-common/types';
function compareIssuedDesc(a, b) {
    return b.rawIssuedOn.getTime() - a.rawIssuedOn.getTime();
}
function compareIssueDateAsc(a, b) {
    return new Date(a.rawIssueDate()).getTime() - new Date(b.rawIssueDate()).getTime();
}
export function selectBillingOverview(issued, futures) {
    var _sortedIssued_, _sortedFutures_;
    const sortedIssued = [
        ...issued
    ].sort(compareIssuedDesc);
    const latest = (_sortedIssued_ = sortedIssued[0]) !== null && _sortedIssued_ !== void 0 ? _sortedIssued_ : null;
    // No id-dedup against `latest`: the card hides the "Latest invoice" section when the latest
    // invoice is overdue, so an overdue latest invoice must appear in the overdue list instead.
    const overdueIssued = sortedIssued.filter((i)=>i.displayStatusV2 === InvoiceDisplayStatusV2.Overdue);
    const sortedFutures = [
        ...futures
    ].sort(compareIssueDateAsc);
    const nextFuture = (_sortedFutures_ = sortedFutures[0]) !== null && _sortedFutures_ !== void 0 ? _sortedFutures_ : null;
    return {
        upcomingInvoice: nextFuture,
        latestInvoice: latest,
        overdueInvoices: overdueIssued
    };
}
